/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { taxCategoriesAssociationsGet } from '../fn/tax-category-associations/tax-categories-associations-get';
import { TaxCategoriesAssociationsGet$Params } from '../fn/tax-category-associations/tax-categories-associations-get';
import { taxCategoriesAssociationsPut } from '../fn/tax-category-associations/tax-categories-associations-put';
import { TaxCategoriesAssociationsPut$Params } from '../fn/tax-category-associations/tax-categories-associations-put';
import { TaxCategoryAssociationListResponse } from '../models/tax-category-association-list-response';
import { TaxCategoryAssociationsUpdateResponse } from '../models/tax-category-associations-update-response';

@Injectable({ providedIn: 'root' })
export class TaxCategoryAssociationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `taxCategoriesAssociationsGet()` */
  static readonly TaxCategoriesAssociationsGetPath = '/tax-categories/associations';

  /**
   * Get Tax Category Associations.
   *
   * catalogEntryId and taxCategoryId cannot be provided together. When neither is provided, all associations for the requesting tenant are returned.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxCategoriesAssociationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxCategoriesAssociationsGet$Response(params: TaxCategoriesAssociationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategoryAssociationListResponse>> {
    return taxCategoriesAssociationsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Tax Category Associations.
   *
   * catalogEntryId and taxCategoryId cannot be provided together. When neither is provided, all associations for the requesting tenant are returned.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxCategoriesAssociationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxCategoriesAssociationsGet(params: TaxCategoriesAssociationsGet$Params, context?: HttpContext): Observable<TaxCategoryAssociationListResponse> {
    return this.taxCategoriesAssociationsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TaxCategoryAssociationListResponse>): TaxCategoryAssociationListResponse => r.body)
    );
  }

  /** Path part for operation `taxCategoriesAssociationsPut()` */
  static readonly TaxCategoriesAssociationsPutPath = '/tax-categories/associations';

  /**
   * Update Tax Category Associations.
   *
   * Replaces the Tax Category associations for one or more Catalog Entries, scoped to the requesting tenant. Each Catalog Entry's resulting set of associations is validated against the maximum-Tax-Categories-per-channel configuration for every aggregator supported by the included Tax Categories.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxCategoriesAssociationsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taxCategoriesAssociationsPut$Response(params: TaxCategoriesAssociationsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategoryAssociationsUpdateResponse>> {
    return taxCategoriesAssociationsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Tax Category Associations.
   *
   * Replaces the Tax Category associations for one or more Catalog Entries, scoped to the requesting tenant. Each Catalog Entry's resulting set of associations is validated against the maximum-Tax-Categories-per-channel configuration for every aggregator supported by the included Tax Categories.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxCategoriesAssociationsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taxCategoriesAssociationsPut(params: TaxCategoriesAssociationsPut$Params, context?: HttpContext): Observable<TaxCategoryAssociationsUpdateResponse> {
    return this.taxCategoriesAssociationsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<TaxCategoryAssociationsUpdateResponse>): TaxCategoryAssociationsUpdateResponse => r.body)
    );
  }

}
